import {
  ATTENDANCE_FETCHING,
  ATTENDANCE_FAILED,
  ATTENDANCE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ATTENDANCE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ATTENDANCE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ATTENDANCE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
